import React from "react";
import ViewFileImg from "../../images/SideBar/viewFile";
import DownloadImg from "../../images/SideBar/download";
import { IDocumentView, IDocumentViewBox } from "./props";
import ImageIco from "../../images/SideBar/ImageIco";

const DocumentView: React.FC<IDocumentView> = ({Title , Link}) => {
  return (
    <div className="document-section flex mt-2">
      <h3 className="mb-2 font-medium text-fontBlack text-sm w-[40%]">
        {Title}:
      </h3>
      <div className="grid xl:grid-cols-2 lg:grid-cols-1 gap-1 -mt-3 p-2 bg-white rounded-md shadow-sm">
        <a
          href={Link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="hover:text-fontColLit6 flex items-center">
            <ViewFileImg />
            <span className="ml-2">View</span>
          </button>
        </a>
        <a
          href={Link}
          target="_blank"
          download
          rel="noopener noreferrer"
        >
          <button className="hover:text-fontColLit6 flex items-center">
            <DownloadImg />
            <span className="ml-2">Download</span>
          </button>
        </a>
      </div>
    </div>
  );
};
export default DocumentView;

export const DocumentViewBox: React.FC<IDocumentViewBox> = ({children}) => {
    return (
        <div className="w-[95%]">
        <th className="text-fontBlack font-semibold  text-sm p-2 flex gap-1 items-center">
          <ImageIco />
          <p className="ml-1">Document Info</p>
        </th>
        <div className="grid grid-cols-1 gap-6 p-4 bg-tableBg rounded-lg">
        {children}
        </div>
      </div>
    );
  };
